<template>
  <SystemError v-if="errorState.isError" />
  <v-app v-else id="lg">
    <Header>
      <template #title>
        <v-toolbar-title>契約者マイページ</v-toolbar-title>
      </template>
    </Header>
    <router-view />
    <Footer />
  </v-app>
</template>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import SystemError from '@/views/SystemError';
import { useIsErrorStore } from '../stores/isError';

export default {
  components: {
    Header,
    Footer,
    SystemError,
  },
  beforeRouteUpdate(to, from, next) {
    this.isError = false;
    next();
  },
  setup() {
    const errorState = useIsErrorStore();
    return {
      errorState,
    };
  },
};
</script>
